// Core
import React from 'react';

// Routing
import Route from '../Route';

// Views
import Stats from './Stats';
import Conversations from './views/Conversations/';
import Teams from './views/Teams/';
import Bots from './views/Bots';
import Ratings from './views/Ratings';
import Tags from './views/Tags';

const routes = new Route({
  path: '/stats',
  children: [
    {
      name: 'Stats - ',
      path: '/conversations',
      requires: ['admin', 'supervisor'],
      action: () => (
        <Stats>
          <Conversations />
        </Stats>
      ),
    },
    {
      name: 'Stats - ',
      path: '/teams',
      requires: ['admin', 'supervisor'],
      action: () => (
        <Stats>
          <Teams />
        </Stats>
      ),
    },
    {
      name: 'Stats - ',
      path: '/bot',
      requires: ['admin', 'supervisor'],
      action: () => (
        <Stats>
          <Bots />
        </Stats>
      ),
    },
    {
      name: 'Stats -',
      path: '/ratings',
      requires: ['admin', 'supervisor'],
      action: () => (
        <Stats>
          <Ratings />
        </Stats>
      ),
    },
    {
      name: 'Stats -',
      path: '/tags',
      requires: ['admin', 'supervisor'],
      action: () => (
        <Stats>
          <Tags />
        </Stats>
      ),
    },
  ],
});

export default routes;
